import React from "react";

const siddhi_landage = () => {
  return (
    <div>
      <h1>Siddhi Landage</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process?
        </strong>
        <br />
        For the aptitude, the shortlisting criteria was all the students above 7
        CGPA. After that, the aptitude test was conducted for all the students
        who were eligible on the college campus.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process?</strong>
        <br />
        The timeline included 2 days. On the 1st day, there was a PPT, after
        that there was an aptitude test. On the next day, there were interviews,
        and in the evening, the results were announced.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        It was conducted online (on the college campus).
        <br />
        <strong>Duration:</strong> 90 min
        <br />
        <strong>Sections:</strong> 2 - MCQs and 2 Coding Questions
        <br />
        MCQs were based on CN, OS, DBMS, Java, and DSA. Questions were on the
        number of subnets, SQL query outputs, OS concepts, and Java code
        snippets (but they were big codes and just required guessing one number
        output).
        <br />
        In the coding section, one of the questions was based on a graph
        approach (medium level). The other question was based on HashMap,
        sorting, and graph, which was more difficult. Passing the maximum number
        of test cases was the key. I was not able to solve the first one due to
        time constraints but got 8-9 test cases correct for the difficult one.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        22 students after the Aptitude Round were selected for the Interview
        Round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        On the 1st day, the aptitude results were announced quite late, around
        11:30 PM, and the interview was scheduled the next day at 8 AM. So,
        there was not much time for extra preparation. I just revised some OOPs
        concepts, DSA concepts, and reviewed coding question approaches. As this
        was my first interview and I was not too good in English communication,
        I tried one mock interview with one of my friends, which really boosted
        my confidence. I didn’t panic much, just kept calm and reminded myself
        that in this short time, I couldn’t do new things - I just needed to
        focus on what I already knew in depth and correctly.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company? Can you
          elaborate about each round in brief? Also mention how many students
          were shortlisted after each Interview Round.
        </strong>
      </p>

      <ol>
        <li>
          <p>
            <strong>Aptitude Round (Online):</strong> This round consisted of
            MCQs and 2 coding questions.
          </p>
        </li>
        <li>
          <p>
            <strong>Technical Interview:</strong> The technical interview was
            conducted for about 30 to 35 minutes. I was asked questions from my
            resume. Some web-related questions were asked since I had mentioned
            two projects on web development and had also contributed to making
            the college fest website. Questions on the POST method were asked.
            Questions on Object-Oriented Programming were asked - the 4 pillars
            of OOP, which I explained with good examples. I was also asked the
            difference between abstraction and encapsulation.
            <br />
            They asked DBMS-related questions (1-2 queries, easy to medium
            level).
            <br />
            I was also asked many things related to Java, like why Java, its
            features, different Maps like HashMap, TreeMap, ArrayList,
            LinkedList, and their working.
            <br />
            String-related topics were also covered, such as StringBuffer,
            StringBuilder, and their use cases.
            <br />
            Lastly, they asked 2 scenario-based questions, like: if there is a
            conflict in a team, how would you solve it, and how do you manage
            all these activities along with your studies?
          </p>
        </li>
        <li>
          <p>
            <strong>Pro-Fit Interview:</strong> The Pro-Fit Interview was
            conducted for about 40-45 minutes. After giving a brief
            introduction, the interviewer asked me questions about my family and
            then moved toward my web development project. They asked me every
            bit and byte of website development and how I dealt with problems to
            see my problem-solving approach. It included a very wide and deep
            conversation that started from how I would choose a team, how I
            would manage it, how website development work would be distributed,
            how our website should be deployed, how security is managed in
            websites, and others as well.
            <br />
            They gave me a task to develop a website for COEP students and asked
            about all these factors. They even asked me about government
            initiatives like apps for security implementation and where they are
            used. Almost 90% of the discussion was based on this. After that,
            they asked me about my hobbies, which included book reading, and
            then a little bit of informal discussion happened on 2-3 books - the
            last read book and why I liked it. At the end of the interview, I
            asked 1-2 questions, which included how they implement security in
            their work and if they had any advice for me. That was an informal
            talk but showed genuine interest in the field and that I acknowledge
            my weaknesses and am open-minded and eager to learn from others’
            experiences. So, it ended on a good note.
          </p>
        </li>
        <li>
          <p>
            <strong>HR Interview:</strong> The HR Interview was conducted for
            about 15 to 20 minutes. I was asked to give a brief introduction. I
            was asked about my family, my hobbies, and my college life. Then I
            was asked about my strengths and weaknesses. I told my weaknesses
            honestly and also explained how I am trying to improve them. Then
            they asked why I wanted to join Deutsche Bank. After that, I asked
            1-2 questions, and the interview ended.
          </p>
        </li>
      </ol>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews?
        </strong>
        <br />
        Mainly focused on the problem-solving approach - it included both
        technical and non-technical aspects. OOPs and DBMS were also asked. In
        the Pro-Fit round, they focused on overall knowledge and problem-solving
        approach, while in HR they focused on my opinions and experiences.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
      </p>

      <ul>
        <li>
          <p>Striver's A2Z DSA Sheet</p>
        </li>
        <li>
          <p>GFG and LeetCode for coding practice</p>
        </li>
        <li>
          <p>
            Striver's SDE Sheet (if DSA sheet is complete, then you can go for
            easy and medium level problems)
          </p>
        </li>
        <li>
          <p>GFG Last Minute Notes</p>
        </li>
        <li>
          <p>DBMS by Love Babbar</p>
        </li>
        <li>
          <p>OS by Love Babbar</p>
        </li>
      </ul>

      <p>
        <strong>Some tips to crack Coding Questions:</strong>
      </p>

      <ol>
        <li>
          <p>Read the question and try to identify a pattern.</p>
        </li>
        <li>
          <p>
            Analyze the test cases and try to come up with a brute-force
            solution.
          </p>
        </li>
        <li>
          <p>
            Try to implement it and then think about an optimal approach and
            implement it.
          </p>
        </li>
        <li>
          <p>
            To get a good understanding of DSA, you can try Striver’s SDE Sheet
            and practice at least one question daily.
          </p>
        </li>
      </ol>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume?
        </strong>
        <br />
        Most of the questions were related to the projects, like what the
        project included, what was the aim, and how it solved the problem. About
        the DSA project, they asked what data structures I used and why.
        Questions about clubs were asked in the first round and in HR also. They
        asked me what my opinion was on the three-language policy as I was in
        the Marathi Debate Club.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company?
        </strong>
        <br />
        Do not include anything in your resume that you are not fully confident
        about. Write less, show more. Know at least a few things about the
        company, and in all rounds show respect to others, show genuine
        interest, and your willingness to work there. Be honest - if you don’t
        know something, say it politely. Prepare well for your project, DSA, and
        OOPs. You can also add DBMS and OS subjects.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Start early and be consistent in your preparation. It may be a tough
        grind initially, but make sure to put your best effort as the result
        would be worth it. Also, don’t panic much about the result - just trust
        the process and your efforts. Be calm and honest. Wish you all the Best
        !
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong>{" "}
        <a href="mailto:landagesh23.comp@coeptech.ac.in">
          landagesh23.comp@coeptech.ac.in
        </a>
      </p>
    </div>
  );
};

export default siddhi_landage;
